import React from 'react';
import {Router, Route} from 'react-router-dom';
import {Redirect, Switch} from "react-router";
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import {connect} from "react-redux";
import {Login, SignUp,Reset, ResetPassword, ChangePassword, Home} from "./modules";
import {history} from "./managers/history";
import BaseComponent from "./modules/baseComponent";
import LoaderComponent from "./common/components/loader";
import VerifyEmailPage from "./modules/verifyEmailPage"

class Routes extends BaseComponent {
    componentDidMount() {
    //  if(!this.props?.user?.IsLoggedIn)
    //      return history.push('/')
        
    }
    
    render() {
        let loader = this.props && this.props.user && this.props.user.loading ? <LoaderComponent /> : null;
        return (
            <MuiThemeProvider muiTheme={getMuiTheme()}>
                 {loader}
                <Router history={history}>
                    <Switch>
                        <Route exact path={'/'} component={Login}/>
                        <Route exact path={'/sign-up'} component={SignUp}/>
                        <Route exact path={'/reset'} component={Reset}/>
                        <Route exact path={'/resetpassword'} component={ResetPassword}/>
                        <Route exact path={'/changePassword'} component={ChangePassword}/>
                        <Route exact path={'/home/:tab'} component={Home}/>
                        <Route exact path={'/verifyEmail'} component={VerifyEmailPage}/>
                        <Redirect exact from='*' to="/"/>
                    </Switch>
                </Router>
            </MuiThemeProvider>);
    }
}

const mapStateToProps = (state) => {
    return {user: state.user}
};
export default connect(mapStateToProps)(Routes);
